<template>
  <header>
    <div class="headerInner">
      <h1><a href="/"><img src="../assets/images/logo.svg" alt="九州離島図鑑"></a></h1>
      <nav class="headerNav">
        <ul>
          <li><a href="../"><img src="../assets/images/search.svg"></a></li>
        </ul>
      </nav>
    </div>
  </header>
  <IslandMapNavi />
  <footer>
    <p><a href=""><img src="../assets/images/logo-w.svg" alt=""></a></p>
    <!--
    <ul>
      <li><a href="">組織概要・当サイトについて</a></li>
      <li><a href="">リンク集</a></li>
      <li><a href="">お問い合わせ・資料請求</a></li>
    </ul>
    -->
  </footer>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import IslandMapNavi from '../components/IslandMapNavi.vue';
export default {
  components: {
    IslandMapNavi,
  },
  data() {
    return {
      base: '', // 初期値を設定
      // items: [] // ダミーデータを入れる場所。適宜変更してください
    };
  },
  computed: {
    // 'island' モジュールから状態をマッピング
    ...mapState('island', ['routeConfigs', 'selectedLanguage', 'filteredRoutes', 'searchQuery', 'currentPage', 'pageSize']),
    ...mapGetters('island', ['paginatedData', 'pageCount']),
    pageCount() {
      return Math.ceil(this.filteredRoutes.length / this.pageSize);
    }
  },
  methods: {
    ...mapActions('island', ['fetchRoutes', 'changeLanguage', 'filterData', 'sortData', 'setCurrentPage', 'updateSearchQuery']),
    ...mapMutations('island', ['setCurrentPage']),
    // searchQueryが変更されたときのイベントハンドラー
    onSearchQueryChange(event) {
      console.log("Search query changed:", event.target.value);  // Check input value
      this.updateSearchQuery(event.target.value);
    }
  },
  created() {
    // console.log("SearchView created()");
    this.fetchRoutes();  // ルートデータの取得
    this.filterData();   // 初期データのフィルタリング
    // Vue Routerのbaseパスを取得
    this.base = this.$router.options.history.base || '';
  }
};
</script>

<style scoped>
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-color: #fff;
  z-index: 999;
}

body {
  font-family: Arial, sans-serif;
  margin: 0;
  background-color: #f4f4f4;
  position: relative;
}

h1 {
  text-align: center;
  color: #333;
}

h2 {
  margin: 10px;
  text-align: center;
  color: #333;
}

.container {
  top: 80px;
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  position: relative;
}

#languageSwitcher {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px;
  border-radius: 4px;
}

#search {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
}

th,
td {
  padding: 12px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
  cursor: pointer;
}

th:hover {
  background-color: #e0e0e0;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

tr:hover {
  background-color: #f1f1f1;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 15px;
  margin: 0 2px;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:hover {
  background-color: #45a049;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: default;
}

@media (max-width: 600px) {
  .container {
    padding: 10px;
  }

  th,
  td {
    padding: 8px;
  }

  #search {
    padding: 8px;
  }

  .pagination button {
    padding: 8px 10px;
    margin: 0 1px;
  }
}
</style>